import { Diagnosis } from "./Diagnosis";

type DiagnosisContainereProps = {
	region: string;
}


const DiagnosisContainer = (props: DiagnosisContainereProps) => {

	return (
		<Diagnosis region={props.region} />
	);
};

export { DiagnosisContainer };